"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asTestableSingleAccordion = exports.asSingleAccordion = exports.TestableSingleAccordion = exports.SingleAccordionClean = exports.SingleAccordion = exports.SingleAccordionBase = void 0;

var react_1 = __importStar(require("react"));

var lodash_1 = require("lodash");

var mobx_react_lite_1 = require("mobx-react-lite");

var fclasses_1 = require("@bodiless/fclasses");

var components_1 = require("@bodiless/components");

var core_1 = require("@bodiless/core");

var singleAccordionComponentStart = {
  Wrapper: fclasses_1.Div,
  TitleWrapper: fclasses_1.Div,
  Title: fclasses_1.H2,
  BodyWrapper: fclasses_1.Div,
  Body: fclasses_1.Div
};
var SingleAccordionBase = mobx_react_lite_1.observer(function (_a) {
  var components = _a.components,
      expanded = _a.expanded,
      _b = _a.expandedStyle,
      expandedStyle = _b === void 0 ? null : _b,
      rest = __rest(_a, ["components", "expanded", "expandedStyle"]);

  var EXPANDED = 'expanded';
  var COLLAPSED = 'collapsed';
  var initialState = expanded ? EXPANDED : COLLAPSED;

  var _c = react_1.useState(initialState),
      accordionState = _c[0],
      setAccordionState = _c[1];

  var isEdit = core_1.useEditContext().isEdit;

  var toggleAccordionState = function toggleAccordionState() {
    setAccordionState(accordionState === EXPANDED ? COLLAPSED : EXPANDED);
  };

  var Wrapper = components.Wrapper,
      TitleWrapper = components.TitleWrapper,
      Title = components.Title,
      BodyWrapper = components.BodyWrapper,
      Body = components.Body;
  return react_1.default.createElement(Wrapper, __assign({
    className: [accordionState]
  }, rest), react_1.default.createElement(TitleWrapper, {
    onClick: isEdit ? undefined : toggleAccordionState,
    className: ['flex', 'justify-between', 'select-none', accordionState === EXPANDED && expandedStyle || '']
  }, react_1.default.createElement(Title, null), react_1.default.createElement("span", {
    tabIndex: 0,
    role: "button",
    onClick: toggleAccordionState,
    className: "material-icons cursor-pointer select-none",
    "data-accordion-element": "accordion-icon",
    "data-accordion-icon": accordionState === COLLAPSED ? 'expand' : 'collapse'
  }, accordionState === COLLAPSED ? 'add' : 'remove')), react_1.default.createElement(BodyWrapper, {
    className: accordionState === COLLAPSED ? 'hidden' : 'block'
  }, react_1.default.createElement(Body, null)));
});
exports.SingleAccordionBase = SingleAccordionBase;
var asSingleAccordion = fclasses_1.withDesign({
  Title: components_1.asEditable('title', 'SingleAccordion Title Text'),
  Body: components_1.asEditable('body', 'SingleAccordion Body Text')
});
exports.asSingleAccordion = asSingleAccordion;
var asTestableSingleAccordion = fclasses_1.withDesign({
  Wrapper: fclasses_1.addProps({
    'data-accordion-element': 'accordion'
  }),
  TitleWrapper: fclasses_1.addProps({
    'data-accordion-element': 'accordion-title-wrapper'
  }),
  Title: fclasses_1.addProps({
    'data-accordion-element': 'accordion-title'
  }),
  BodyWrapper: fclasses_1.addProps({
    'data-accordion-element': 'accordion-body-wrapper'
  }),
  Body: fclasses_1.addProps({
    'data-accordion-element': 'accordion-body'
  })
});
exports.asTestableSingleAccordion = asTestableSingleAccordion;
var SingleAccordionClean = lodash_1.flow(fclasses_1.designable(singleAccordionComponentStart, 'Accordion'))(SingleAccordionBase);
exports.SingleAccordionClean = SingleAccordionClean;
var SingleAccordion = lodash_1.flow(asSingleAccordion, core_1.withNode)(SingleAccordionClean);
exports.SingleAccordion = SingleAccordion;
var TestableSingleAccordion = lodash_1.flow(asTestableSingleAccordion, core_1.withNode)(SingleAccordionClean);
exports.TestableSingleAccordion = TestableSingleAccordion;
exports.default = SingleAccordion;